import { Typography } from "@mui/material";

import HNSColors from "../../../../../../ui library/HNSColors";

export default function ModalHeader({ modeLabel, relationTypeValue }) {
  return (
    <>
      <Typography className="text-[32px] font-semibold">{modeLabel} Contact</Typography>
      <Typography className="text-2xl font-normal" sx={{ color: HNSColors.neutrals[500] }}>
        {relationTypeValue}
      </Typography>
    </>
  );
}
